import Playback from './playback';
var Singleton = /** @class */ (function () {
    function Singleton() {
    }
    Singleton.getInstance = function () {
        Singleton._instance = Singleton._instance || new Playback();
        return Singleton._instance;
    };
    return Singleton;
}());
export default Singleton;
//# sourceMappingURL=singleton.js.map